module.exports = __webpack_public_path__ + "static/media/icon-checkbox-on.dea4e434.svg";